import React, { memo, ReactNode } from 'react';
import classNames from 'classnames';

type WizardWrapperProps = {
  children?: ReactNode;
  testId: string;
};

export const WizardWrapper = memo(
  function WizardWrapper({ children, testId }: WizardWrapperProps) {
    const baseString = 'wizard-wrapper';
    const classString = classNames(`${baseString}`);

    return (
      <main className={classString} data-test-id={`${testId}-wrapper`}>
        {children}
      </main>
    );
  }
);
